import { render } from "./A4.vue?vue&type=template&id=aa809822&scoped=true"
import script from "./A4.vue?vue&type=script&lang=js"
export * from "./A4.vue?vue&type=script&lang=js"

import "./A4.vue?vue&type=style&index=0&id=aa809822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa809822"]])

export default __exports__